<div class="container">
    <!-- Our components will be loaded here based on the current URL -->
    <router-outlet></router-outlet>
  </div>